import { computed } from 'vue'
import moment from 'moment'

const URLS = {
    images: {
        defaultUserImage: '/images/global/default.png',
        defaultEventImage: '/images/default-artist-event.png'
    }
}
export const useVenueEvent = (event) => {
    const venueEventVibes = computed(() => event.value.array_keywords)
    const venueEventImage = computed(() => {
        if (event.value.image && !event.value.image.includes(URLS.images.defaultUserImage)) {
            return event.value.image
        } else if (
            (!event.value.image && !event.value.venue.avatar) ||
            event.value.venue.avatar.includes(URLS.images.defaultUserImage)
        ) {
            return URLS.images.defaultEventImage
        } else {
            return event.value.venue.avatar
        }
    })
    const venueEventDate = computed(() => {
        const startDate = event.value.start.split(' ')[0]
        return moment(startDate).format('MMMM DD, YYYY')
    })
    const venueEventArtists = computed(() => {
        switch (event.value.status) {
            case 0:
            case 1:
                return _invitedAppliedBookedOrNone.value
            case 2:
            case 3:
            case 4:
            case 5:
                return _withArtistNames.value
        }
    })
    const _invitedAppliedBookedOrNone = computed(() => {
        const appliedArtists = event.value.responded_artist.filter((a) => a.status === 0).length
        const bookedArtists = event.value.responded_artist.filter((a) => a.status === 3).length

        if (event.value.invited_artists === 0 && event.value.responded_artist.length === 0) {
            return 'No artists have been invited yet'
        } else if (event.value.responded_artist.length === 0) {
            return 'None of the artists have applied yet'
        } else if (appliedArtists && bookedArtists) {
            return `${appliedArtists} ${
                appliedArtists === 1 ? 'artist has' : 'artists have'
            } applied and ${bookedArtists} ${bookedArtists === 1 ? 'artist' : 'artists'} booked`
        } else if (appliedArtists && !bookedArtists) {
            return `${appliedArtists} ${appliedArtists === 1 ? 'artist has' : 'artists have'} applied`
        } else if (!appliedArtists && bookedArtists) {
            return `${bookedArtists} ${bookedArtists === 1 ? 'artist' : 'artists'} booked`
        } else {
            return 'None of the artists have applied or booked yet'
        }
    })
    const _withArtistNames = computed(() => {
        let artists = ''
        const bookedArtists = event.value.responded_artist.filter((a) => a.status === 3)
        if (bookedArtists.length > 3) {
            artists = bookedArtists
                .slice(0, 3)
                .map((a) => a.band_name)
                .join(', ')
            artists = `With ${artists} and ${bookedArtists.length - 3} more...`
        } else {
            artists = bookedArtists.map((a) => a.band_name).join(', ')
            artists = `With ${artists}`
        }
        return artists
    })
    const venueLocation = computed(() =>
        event.value.venue_location ? event.value.venue_location.replace(/\d+/, '').trim() : ''
    )
    const venuePayout = computed(() => {
        switch (event.value.status) {
            case 0:
            case 1:
                return {
                    label: 'Est. Payout',
                    value: `${_venuePayoutValue.value}`
                }
            case 2:
            case 3:
            case 4:
            case 5:
                return {
                    label: 'Final Payouts',
                    value: `${_venuePayoutValue.value}`
                }
        }
    })
    const _venuePayoutValue = computed(() => {
        if (event.value.status === 0 || event.value.status === 1) {
            return !event.value.budget || event.value.budget === '0.00'
                ? 'N/A'
                : `Up to $${parseFloat(event.value.budget).toFixed(0)}`
        } else {
            return `$${parseFloat(event.value.total_payout).toFixed(0)}`
        }
    })
    const venueCta = computed(() => {
        switch (event.value.status) {
            case 0:
            case 1: {
                if (event.value.responded_artist.length === 0) {
                    return {
                        text: 'Invite Artists',
                        display: null
                    }
                } else if (event.value.responded_artist.every((artist) => artist.status === 3)) {
                    return {
                        text: 'Finalize Lineup',
                        display: null
                    }
                } else {
                    return {
                        text: 'Review Offers',
                        display: null
                    }
                }
            }
            case 2:
                return {
                    text: 'Promote Event',
                    display: null
                }
            case 3:
                return {
                    text: 'Review Artist',
                    display: null
                }
            case 4:
            case 5:
            case 6:
                return {
                    text: null,
                    display: 'none'
                }
        }
    })
    const venueEventLabel = computed(() => {
        switch (event.value.status) {
            case 4:
                return 'Completed!'
            case 5:
                return 'Cancelled!'
            case 0:
            case 1:
            case 2:
            case 3:
            case 6:
                return ''
        }
    })

    return {
        venueEventLabel,
        venueEventVibes,
        venueEventImage,
        venueEventDate,
        venueEventArtists,
        venueLocation,
        venuePayout,
        venueCta
    }
}
